import * as React from 'react';
import classNames from 'classnames';
import * as Classes from '../common/classes';
import { BaseProps } from '../common/props';
import { useInverseBg } from '../theme/useInverseBg';

export interface ILabelProps extends BaseProps {
  /**
   * Intent labelu, pokud není uvedeno, je none.
   */
  intent?: 'inactive' | 'default';
  /**
   * Inverzní verze - typicky používáme na tmavším pozadí.
   */
  inverse?: boolean;
  /**
   * Pokud je true, tak se label zobrazí jako povinný.
   */
  required?: boolean;
}

export type LabelProps = ILabelProps;

/**
 * Komponenta labelu.
 */
export const Label = ({
  className,
  children,
  style,
  intent,
  inverse,
  required,
  ...other
}: LabelProps) => {
  const parentInverse = useInverseBg(inverse);

  let cls = classNames(Classes.LABEL, className, {
    [Classes.TYPOGRAPHY_INACTIVE]: intent === 'inactive',
    [Classes.TYPOGRAPHY_INVERSE]: parentInverse,
    [Classes.RF_REQUIRED]: required,
  });

  return (
    <div {...other} className={cls} style={style}>
      {children}
    </div>
  );
};
